
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wydanie",
      function () {
        return require("private-next-pages/wydanie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wydanie"])
      });
    }
  